import React from 'react';
import { DefaultBsComponent } from '../../types/module';
import { classNames } from '../../utils/style';

export type PricingCTAProps = DefaultBsComponent;
export const CTA = ({ children, className }: PricingCTAProps) => {
  return <div className={classNames('w-full', className)}>{children}</div>;
};
